import { useCallback } from 'react';
import { isSafari } from '@/utils/platformUtils';
import { ISpeechRecognition } from '@/types/speechRecognition';

export const useSpeechRecognitionConfig = () => {
  const initializeSpeechRecognition = useCallback(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      console.error('Speech Recognition not available');
      return null;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = 'es-ES';
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.maxAlternatives = 1;

    // Don't stop on silence
    recognition.continuous = true;

    // Add error handling
    recognition.onerror = (event) => {
      console.error('Speech recognition error:', event.error);
      if (event.error === 'no-speech') {
        console.log('No speech detected');
      }
    };

    return recognition;
  }, []);

  return { initializeSpeechRecognition };
};